import { useMutation, useQueryClient } from '@tanstack/react-query'

import { prayApi } from '../../pray/api/prayApi'
import { PRAY_OBJECT_TYPE } from '../../pray/models/prayObjectType'
import { getCommentResponsesOptions } from './useCommentResponsesQuery'
import { getCommentsOptions } from './useCommentsQuery'

export const usePrayCommentResponseMutation = (commentId: number, publicationId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => prayApi.createPrayer({ objectId: id, objectType: PRAY_OBJECT_TYPE.COMMENT }),
    async onSuccess(_, id) {
      queryClient.setQueryData(getCommentResponsesOptions(commentId).queryKey, (data) =>
        data?.map((comment) =>
          comment.id === id ? { ...comment, hasPrayed: true, prayersCount: comment.prayersCount + 1 } : comment,
        ),
      )

      queryClient.setQueryData(
        getCommentsOptions(publicationId).queryKey,
        (data) =>
          data && {
            ...data,
            pages: data.pages.map((commentsThread) =>
              commentsThread.map((comment) => ({
                ...comment,
                responses: comment.responses?.map((res) =>
                  res.id === id ? { ...res, hasPrayed: true, prayersCount: res.prayersCount + 1 } : res,
                ),
              })),
            ),
          },
      )
    },
  })
}
